import localStorage from '@/utils/localStorage.js';

function downloadApp() {
  let downloadUrl;

  const ptid = localStorage.get( 'ptid' ) || '';

  if ( ptid === 'vivo2021' ) {
    downloadUrl
      = 'https://h5coml.vivo.com.cn'
      + '/h5coml/appdetail_h5/browser_v2/index.html'
      + '?appId=49803&resource=301&source=7';
  } else {
    downloadUrl
      = 'https://a.app.qq.com/o/simple.jsp'
      + '?pkgname=com.gtgj.view';
  }

  location.href = downloadUrl;
}

export default downloadApp;



// WEBPACK FOOTER //
// ./src/projects/vipCard/Helper/download-app.js